import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/common';
import { IOuter } from '../EmptyState.types';
import { useTrackErrorStateAnalytics } from '../../../../utils/hooks/bi/useTrackErrorStateAnalytics';

export const RefreshButton: FC<IOuter> = ({ source, settingsLayout }) => {
  const { trackTryAgainButtonClick } = useTrackErrorStateAnalytics();
  const clickHandler = useCallback(() => {
    trackTryAgainButtonClick(source, settingsLayout);
  }, [source, settingsLayout, trackTryAgainButtonClick]);

  return (
    <Button size="small" skin="standard" priority="secondary" onClick={clickHandler}>
      <FormattedMessage id="empty-state.network-error-link" />
    </Button>
  );
};
